<template>
  <section id="viewOpenpaySuccess">
      <big><i class="fa fa-check"></i></big>
      <h1>Pago recibido exitosamente</h1>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="less">
    #viewOpenpaySuccess {
      text-align: center;
      padding-bottom: 2em;
      min-height: calc(100vh - 580px);
        big {
            font-size: 7em;
            color: #000000;
            position: relative;
            top: 0.45em;
        }
        h1 {
          padding: 1em 1em;
        }
    }
</style>